import { create } from "zustand"

interface NotificationState {
  unreadCount: number
  setUnreadCount: (count: number) => void
  increment: () => void
}

export const useNotificationStore = create<NotificationState>((set) => ({
  unreadCount: 0,
  setUnreadCount: (count) => set({ unreadCount: count }),
  increment: () => set((state) => ({ unreadCount: state.unreadCount + 1 })),
}))
